import { css, styled } from '../../../theme';

export const StyledPanel = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-radius: ${theme.radiuses.base};
    background-color: ${theme.colors.white};

    ${theme.tokens.media.down('desktop')} {
      border-radius: 0;
    }
  `}
`;
